<template>
  <div>
    <loader v-if="loading" />
    <template v-else>
      <div class="mb-md-3">
        <!-- Info Guide -->
        <info-guide
          v-if="guideVisibleFirstTime"
          type="revenueStreamsExamples"
          visible
          @click="closeInfoFirstTime"
        />
        <!-- /Info Guide -->

        <div class="d-flex justify-content-end margin-guide-not-visible" />
      </div>
    </template>

    <!-- Revenue Streams Tabs -->
    <revenue-streams-tabs v-if="!loading" class="mb-4" :disabled="aiTemplateLoader" />
    <!-- /Revenue Streams Tabs -->

    <!-- Revenue Streams List -->
    <revenue-streams-list class="mb-4" :disabled="aiTemplateLoader" />
    <!-- /Revenue Streams List -->

    <!-- Add More Details -->
    <add-more-details
      v-if="!loading"
      :category="'forecast'"
      :step="'revenue-stream'"
      :concept-name="'revenueStreamsMoreDetails'"
      :completed-step-name="'revenueStreamsCompleted'"
    />
    <!-- /Add More Details -->

    <!-- Info Guide Drawer -->
    <info-guide-drawer
      type="revenueStreamsExamples"
      :visible="guideVisible"
      @close="guideVisible = false;"
    />
    <!-- /Info Guide Drawer -->

    <!-- Ai Buddy Drawer -->
    <ai-buddy-drawer
      :visible="aiBuddyDrawerVisible"
      type="revenue-stream"
      @close="aiBuddyDrawerVisible = false"
    />
    <!-- /Ai Buddy Drawer -->
  </div>
</template>

<script>
import { mapState } from 'vuex'

import AddMoreDetails from '@/views/Home/StoryMode/Components/AddMoreDetails.vue'
import AiBuddyDrawer from '@/views/Home/StoryMode/Components/AiBuddy/AiBuddyDrawer.vue'
import EventBus from '@/event-bus'
import InfoGuide from '@/views/Home/StoryMode/Components/Example/InfoGuide.vue'
import InfoGuideDrawer from '@/views/Home/StoryMode/Components/Example/InfoGuideDrawer.vue'
import Loader from '@/components/Loader'
import MixinAiBuddyDrawer from '@/mixins/aiBuddyDrawer'
import MixinAiTemplate from '@/mixins/aiTemplate'
import MixinGuide from '@/mixins/guide'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'
import RevenueStreamsList from '@/views/Home/StoryMode/FinancialPlan/Components/Revenue/RevenueStreamsList.vue'
import RevenueStreamsTabs from '@/views/Home/StoryMode/FinancialPlan/Components/Revenue/RevenueStreamsTabs.vue'

export default {
  name: 'Revenue',

  components: {
    RevenueStreamsTabs,
    AddMoreDetails,
    RevenueStreamsList,
    InfoGuide,
    AiBuddyDrawer,
    InfoGuideDrawer,
    Loader
  },

  mixins: [
    MixinGuide,
    MixinIdeaRoles,
    MixinAiBuddyDrawer,
    MixinAiTemplate
  ],

  data () {
    return {
      loading: false
    }
  },

  computed: {
    ...mapState(['idea'])
  },

  mounted () {
    this.openGuide('revenueStreamFinancialPlanGuide')

    EventBus.$on('loading', (payload) => {
      this.loading = payload
    })

    EventBus.$on('open-info', () => {
      this.guideVisible = true
    })

    EventBus.$on('close-info-first-time', () => {
      this.guideVisibleFirstTime = false
    })
  },

  beforeDestroy () {
    EventBus.$off('loading')
    EventBus.$off('open-info')
    EventBus.$off('close-info-first-time')
  }
}
</script>
